<template>
  <div>
    <dx-data-grid
      ref="dataGrid"
      :columns="columns"
      :data-source="store"
      :remote-operations="remoteOperations"
      :column-auto-width="true"
      :show-borders="true"
      :show-row-lines="false"
      :show-column-lines="true"
      :row-alternation-enabled="true"
      @toolbar-preparing="onToolbarPreparing"
    >
      <dx-editing :allow-deleting="true"/>

      <dx-sorting mode="multiple"/>

      <dx-filter-row :visible="true"/>
      <dx-filter-panel :visible="true"/>

      <dx-paging :page-size="20"/>
      <dx-pager
        :allowed-page-sizes="[15, 20, 50]"
        :visible="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid } from 'devextreme-vue';
import {
  DxEditing,
  DxFilterPanel,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxSorting,
} from 'devextreme-vue/data-grid';
import { confirm } from 'devextreme/ui/dialog';
import createBackendStore from '@/lib/create-backend-store';
import { buildColumns } from '@/lib/data-grid-columns';
import filterToWhere from '@/lib/dx/filter/filter-to-where';

export default {
  name: 'MissingLocaleGrid',
  components: {
    DxDataGrid,
    DxEditing,
    DxFilterRow,
    DxFilterPanel,
    DxPager,
    DxPaging,
    DxSorting,
  },
  props: {
    namespace: { type: String, default: 'default' },
  },
  data() {
    return {
      columns: [],
      store: null,
      remoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
    };
  },
  computed: {
    dataGrid() {
      return this.$refs.dataGrid.instance;
    },
  },
  watch: {
    namespace(value) {
      this.dataGrid.columnOption('namespace', 'filterValue', value);
    },
  },
  methods: {
    buildColumns,
    configureColumns() {
      return [
        ...this.buildColumns('missingLocale', [
          {
            property: 'namespace',
            visible: false,
            filterOperations: ['='],
          },
          {
            property: 'key',
          },
          {
            property: 'lastRequestAt',
            width: '20%',
            sortOrder: 'desc',
          },
          {
            property: 'requestCount',
            width: '10%',
            sortOrder: 'desc',
          },
        ]),
        {
          type: 'buttons',
          buttons: [
            {
              text: this.$t('common.add'),
              icon: 'add',
              onClick: event => this.$emit('click:showCreateLocaleDialog', event.row.data),
            },
            'delete',
          ],
          width: 70,
        },
      ];
    },
    configureStore(columns) {
      return createBackendStore('/missing-locales', {
        fields: columns.map(c => c.dataField)
          .filter(f => !!f),
      });
    },
    refresh() {
      this.dataGrid.refresh();
    },
    async cleanUp() {
      const params = { cleanUp: true, namespace: this.namespace };

      await this.$http.delete('/missing-locales', { params });

      this.refresh();
    },
    async deleteAll() {
      const message = this.$t('components.missingLocaleGrid.deleteAll.confirmMessage');

      const result = await confirm(message, '', false);

      if (result) {
        const filter = this.dataGrid.getCombinedFilter();
        const params = { where: filterToWhere(filter) };

        await this.$http.delete('/missing-locales', { params });
        this.refresh();
      }
    },
    onToolbarPreparing(event) {
      event.toolbarOptions.items.push({
        location: 'after',
        widget: 'dxButton',
        options: {
          text: this.$t('common.cleanUp'),
          onClick: this.cleanUp,
          hint: this.$t('common.cleanUpHint'),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'trash',
          onClick: this.deleteAll,
          hint: this.$t('common.deleteAll'),
        },
      });
    },
  },
  created() {
    this.columns = this.configureColumns();
    this.store = this.configureStore(this.columns);
  },
  mounted() {
    this.dataGrid.columnOption('namespace', 'filterValue', this.namespace);
  },
};
</script>

<style scoped>

</style>
